import classNames from "classnames";
import CollegeLogo from "rivals/components/shared/CollegeLogo";
import Link from "rivals/components/shared/Link";
import TextCell from "rivals/components/shared/Tables/Cells/TextCell";
import { setData } from "rivals/shared/utils/qa";
import styles from "./index.module.scss";
import type { Props } from "./types";

// College cell - applicable to named college activity for athlete tables
const CollegeCell = ({
  collegeName,
  collegeLogo,
  collegeColor,
  fontSize,
  inverted,
  overrideText,
  link,
  className
}: Props): JSX.Element => {
  const label = (
    <>
      <CollegeLogo
        collegeLogo={collegeLogo}
        collegeName={collegeName}
        collegeSiteColor={collegeColor}
        logoSize={36}
      />
      <div className={styles[`text${inverted ? "Inverted" : ""}`]}>
        <TextCell
          fontSize={fontSize}
          text={overrideText || collegeName}
          textColor={link ? "callToActionBlue" : undefined}
        />
      </div>
    </>
  );

  return (
    <div className={classNames(className, styles.collegeCellWrapper)}>
      {link ? (
        <Link
          className={styles[`labelWrapper${inverted ? "Inverted" : ""}`]}
          href={link}
          onClick={(e): void => {
            // stop propagation so that clicking link doesn't trigger onClick handlers of parent table row
            e.stopPropagation();
          }}
          {...setData("college-cell-link")}
        >
          {label}
        </Link>
      ) : (
        <div className={styles[`labelWrapper${inverted ? "Inverted" : ""}`]}>
          {label}
        </div>
      )}
    </div>
  );
};

export default CollegeCell;
